var GOAL_OPTIONS = ["Kommunikation", "Vertrauen & Zusammenhalt", "Problemlösung & Strategie", "Kennenlernen / Icebreaker", "Konfliktlösung", "Motivation & Energie"];
var goals = [{
	value: "Vertrauen & Zusammenhalt",
	custom: ""
}, {
	value: "Kommunikation",
	custom: ""
}];

function renderGoals() {
	var list = document.getElementById('goal-list');
	list.innerHTML = '';
	goals.forEach(function(g, i) {
		var row = document.createElement('div');
		row.className = 'goalrow';
		var select = document.createElement('select');
		GOAL_OPTIONS.forEach(function(opt) {
			var o = document.createElement('option');
			o.value = opt;
			o.textContent = opt;
			if (opt === g.value) o.selected = true;
			select.appendChild(o);
		});
		var customOpt = document.createElement('option');
		customOpt.value = 'eigene';
		customOpt.textContent = 'Eigene Eingabe...';
		if (g.value === 'eigene') customOpt.selected = true;
		select.appendChild(customOpt);
		select.addEventListener('change', function() {
			goals[i].value = select.value;
			update();
		});
		row.appendChild(select);
		if (g.value === 'eigene') {
			var input = document.createElement('input');
			input.type = 'text';
			input.placeholder = 'Eigenes Lernziel';
			input.value = g.custom;
			input.addEventListener('input', function() {
				goals[i].custom = input.value;
				update();
			});
			row.appendChild(input);
		}
		if (goals.length > 1) {
			var rm = document.createElement('button');
			rm.type = 'button';
			rm.className = 'smallbtn';
			rm.innerHTML = '<i class="ti ti-x" aria-hidden="true"></i>';
			rm.addEventListener('click', function() {
				goals.splice(i, 1);
				renderGoals();
				update();
			});
			row.appendChild(rm);
		}
		list.appendChild(row);
	});
	document.getElementById('add-goal').style.display = goals.length >= 4 ? 'none' : 'inline-flex';
}
document.getElementById('add-goal').addEventListener('click', function() {
	if (goals.length < 4) {
		goals.push({
			value: GOAL_OPTIONS[0],
			custom: ''
		});
		renderGoals();
		update();
	}
});
document.getElementById('heading-input').addEventListener('input', function() {
	document.getElementById('out-heading').textContent = this.value || 'Fröbelturm auf einen Blick';
});
document.getElementById('subheading-input').addEventListener('input', function() {
	document.getElementById('out-subheading').textContent = this.value;
});

function update() {
	var platz = document.getElementById('platz');
	var fullTxt = platz.options[platz.selectedIndex].text;
	var sqmPart = fullTxt.match(/~[^,]+/);
	var namePart = fullTxt.split('(')[0].trim();
	document.getElementById('out-platz').textContent = namePart + ' (' + (sqmPart ? sqmPart[0] : '') + ')';
	var pmin = parseInt(document.getElementById('pmin').value) || 1;
	var pmax = parseInt(document.getElementById('pmax').value) || pmin;
	document.getElementById('out-personen').textContent = pmin + '–' + pmax;
	var alter = parseInt(document.getElementById('alter').value) || 0;
	document.getElementById('out-alter').textContent = 'ab ' + alter + ' Jahren';
	var dmin = parseInt(document.getElementById('dmin').value) || 0;
	var dmax = parseInt(document.getElementById('dmax').value) || dmin;
	document.getElementById('out-dauer').textContent = 'ca. ' + dmin + '–' + dmax + ' Min.';
	var goalOut = document.getElementById('out-lernziele');
	goalOut.innerHTML = '';
	goals.forEach(function(g) {
		var text = g.value === 'eigene' ? (g.custom || 'Eigenes Lernziel') : g.value;
		var pill = document.createElement('span');
		pill.className = 'goalpill';
		pill.textContent = text;
		goalOut.appendChild(pill);
	});
	var diff = parseInt(document.getElementById('schwierigkeit').value);
	document.getElementById('diff-pointer').style.left = diff + '%';
	var diffLabel = diff <= 20 ? 'Leicht' : diff <= 40 ? 'Locker anspruchsvoll' : diff <= 60 ? 'Mittel' : diff <= 80 ? 'Anspruchsvoll' : 'Hohe Anforderung';
	document.getElementById('diff-out').textContent = diffLabel;
	var mod = parseInt(document.getElementById('mod').value);
	document.getElementById('mod-pointer').style.left = mod + '%';
	var modLabel = mod <= 20 ? 'Einfach' : mod <= 40 ? 'Leichter Anspruch' : mod <= 60 ? 'Mittel' : mod <= 80 ? 'Erhöhter Anspruch' : 'Hohe Anforderung';
	document.getElementById('mod-out').textContent = modLabel;
}
['platz', 'pmin', 'pmax', 'alter', 'dmin', 'dmax', 'schwierigkeit', 'mod'].forEach(function(id) {
	document.getElementById(id).addEventListener('input', update);
	document.getElementById(id).addEventListener('change', update);
});
renderGoals();
update();